import Vue from "vue";
import VueI18n from "vue-i18n";
import _ from "lodash";
import zh from "./zh";
import en from "./en";
import tw from "./tw";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import enLocale from "element-ui/lib/locale/lang/en";
import twLocale from "element-ui/lib/locale/lang/zh-TW";
import zhSidebar from "./sideMenu/zh";
import enSidebar from "./sideMenu/en";
Vue.use(VueI18n);
const lang = "zh";
Vue.config.lang = lang;

Vue.locale = () => { };
const messages = {
  'zh-cn': _.merge(zhLocale, zh, zhSidebar),
  'en': _.merge(enLocale, en, enSidebar),
  'zh-tw': _.merge(twLocale, tw, zhSidebar),
};
const i18n = new VueI18n({
  locale: "zh-cn", // 语言标识
  messages,
});

export default i18n;
export { messages }
